
import router from '../router'
import { PRODUCT_TYPE_NAME } from '../config/constant'
import { log } from 'echarts/types/src/util/log.js';

export function goToUser(search_query: string | number) {
  return router.push({
    name: 'User',   // 你的路由 name
    query: { search_query: String(search_query) }
  });
}

export function goToPet(query: any) {
  return router.push({
    name: 'Pet',   // 你的路由 name
    query: { search_query: query.search_query, owner_account: query.owner_account }
  });
}

export function goToDevice(other_uuid: string | number) {
  return router.push({
    name: 'Device',   // 你的路由 name
    query: { other_uuid: String(other_uuid) }
  });
}

export const getImageUrl = (uuid: string) => {
  if (!uuid) return ''
  return `https://petsnowy-public.oss-cn-shenzhen.aliyuncs.com/picture/${uuid}`
}


export const getAvatarUrl = (uuid: string) => {
  if (!uuid) return 'http://static.app.petsnowy.com/picture/default/user_avatar.jpeg'
  return `https://petsnowy-public.oss-cn-shenzhen.aliyuncs.com/picture/${uuid}`
}


export const formatDate = (date: Date) => {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}


const getUserTimezone = (): number => {
  if (typeof window === 'undefined') return 8
  const savedTimezone = localStorage.getItem('userTimezone')
  return savedTimezone ? parseInt(savedTimezone, 10) : 8
}

/**
 * 根据localStorage中所选时区，转换时间字符串
 * @param isoString 后端时间字符串，如 "2025-11-21T14:51:59.978651"
 * @returns 格式化后的时间字符串 "2025/11/21 22:51:59"
 */
export const formatTimeByTimezone = (isoString: string): string => {
  if (isoString == null) {
    return "-"
  }
  try {
    const timezoneOffset = getUserTimezone()
    const date = new Date(isoString)
    const utc = date.getTime() + (date.getTimezoneOffset() * 60000)
    const newDate = new Date(utc + (3600000 * timezoneOffset))

    return newDate.toLocaleString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })
  } catch (error) {
    console.error('时间格式化错误:', error)
    return isoString
  }
}



export const verifyPermission = (permission: string): boolean => {
  const userItem = localStorage.getItem('userInfo')
  if (!userItem) return false
  
  try {
    const userInfo = JSON.parse(userItem)
    console.log('userInfo', userInfo)
    
    // 检查 permission_list 是否存在且是数组
    if (Array.isArray(userInfo?.permission_list)) {
      // 使用 includes 检查数组是否包含该权限
      const hasPermission = userInfo.permission_list.includes(permission)
      return hasPermission
    }
    return false
  } catch (error) {
    console.error('解析用户信息失败:', error)
    return false
  }
}